// extracted by mini-css-extract-plugin
module.exports = {"inputWrapper":"styles_inputWrapper__HAd1b","inputWithLabel":"styles_inputWithLabel__35mxi","label":"styles_label__2VwP8","currency":"styles_currency__1IHht"};